var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu03Outlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11C16 11.4142 15.6642 11.75 15.25 11.75H8.75C8.33579 11.75 8 11.4142 8 11C8 10.5858 8.33579 10.25 8.75 10.25H15.25C15.6642 10.25 16 10.5858 16 11Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15C14 15.4142 13.6642 15.75 13.25 15.75H8.75C8.33579 15.75 8 15.4142 8 15C8 14.5858 8.33579 14.25 8.75 14.25H13.25C13.6642 14.25 14 14.5858 14 15Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C8.89543 2 8 2.89543 8 4H6C4.89543 4 4 4.89543 4 6V21C4 22.1046 4.89543 23 6 23H18C19.1046 23 20 22.1046 20 21V6C20 4.89543 19.1046 4 18 4H16C16 2.89543 15.1046 2 14 2H10ZM14.5 4C14.5 3.72386 14.2761 3.5 14 3.5H10C9.72386 3.5 9.5 3.72386 9.5 4V5.5C9.5 5.77614 9.72386 6 10 6H14C14.2761 6 14.5 5.77614 14.5 5.5V4ZM16 5.5C16 6.60457 15.1046 7.5 14 7.5H10C8.89543 7.5 8 6.60457 8 5.5H6C5.72386 5.5 5.5 5.72386 5.5 6V21C5.5 21.2761 5.72386 21.5 6 21.5H18C18.2761 21.5 18.5 21.2761 18.5 21V6C18.5 5.72386 18.2761 5.5 18 5.5H16Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu03Outlined);
export default __webpack_public_path__ + "static/media/icon_menu03_outlined.64abd06623070d49b0c5dbb0f3275185.svg";
export { ForwardRef as ReactComponent };